import UltMeta, { Meta } from "@/meta/UltMeta/index";

class InvoiceState extends UltMeta {
    INVOICE = new Meta(2, "是", "color-info");
    NOT_INVOICE = new Meta(1, "否", "color-black");
}
export const INVOICE_STATE = new InvoiceState();

class ReconciliationState extends UltMeta {
    SIGNING = new Meta(2, "签署中", "color-black");
    REJECTED = new Meta(3, "已驳回", "color-black");
    COMPLETED = new Meta(4, "已完成", "color-info");
    INVALIDING = new Meta(5, "作废中", "color-primary");
    INVALID = new Meta(6, "已作废", "color-info");
}
export const RECONCILIATION_STATE = new ReconciliationState();

class ReconciliationType extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "直采-采购商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "联合采购-采购商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合采购-联合购销商");
}
export const RECONCILIATION_TYPE = new ReconciliationType();
